/**
 * Where the "confirm your email" step may send a person next. A `next` value arrives in a URL, so it
 * is never trusted as a destination: only these exact in-app shapes are followed, everything else is
 * ignored and the person lands where their account says they belong. No scheme, host, `//`, `..` or
 * query string can pass.
 */
const ID = "[A-Za-z0-9_-]{6,64}";
const ALLOWED = [
  /^\/start$/,
  new RegExp(`^/accept-invitation/${ID}$`),
  new RegExp(`^/super-admin/accept-invitation/${ID}$`),
];

export function safeNext(value: string | null | undefined): string | null {
  if (!value || value.length > 200) return null;
  return ALLOWED.some((re) => re.test(value)) ? value : null;
}

/** the confirmation page, carrying where to go afterwards (used as the link's callbackURL too) */
export function verifyEmailPath(next: string | null | undefined): string {
  const n = safeNext(next);
  return n ? `/verify-email?next=${n}` : "/verify-email";
}
